module.exports = __webpack_public_path__ + "img/help_dataset_state2.76d76107.png";